import React from 'react';

function DownloadIcon({ ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="16"
            viewBox="0 0 19 16"
            fill="none"
            {...props}
        >
            <path
                d="M11.9849 10.7497H14.5924C16.1083 10.7497 17.3373 9.52077 17.3373 8.00488C17.3373 6.48889 16.2456 5.26007 14.7297 5.26007C14.7297 3.74408 13.5008 2.51526 11.9849 2.51526C11.658 2.51526 11.3488 2.5821 11.0581 2.68698C10.3033 1.75251 9.16243 1.14286 7.86767 1.14286C5.5938 1.14286 3.75045 2.9862 3.75045 5.26007C2.23456 5.26007 1.14288 6.48889 1.14288 8.00488C1.14288 9.52077 2.3718 10.7497 3.88769 10.7497H6.49526"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.9849 10.7497H14.5924C16.1083 10.7497 17.3373 9.52077 17.3373 8.00488C17.3373 6.48889 16.2456 5.26007 14.7297 5.26007C14.7297 3.74408 13.5008 2.51526 11.9849 2.51526C11.658 2.51526 11.3488 2.5821 11.0581 2.68698C10.3033 1.75251 9.16243 1.14286 7.86767 1.14286C5.5938 1.14286 3.75045 2.9862 3.75045 5.26007C2.23456 5.26007 1.14288 6.48889 1.14288 8.00488C1.14288 9.52077 2.3718 10.7497 3.88769 10.7497H6.49526M9.24007 6.63248V14.857M7.18146 13.0828L8.75486 14.6562C9.02282 14.9241 9.45732 14.9241 9.72528 14.6562L11.2987 13.0828"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default DownloadIcon;
